module.exports = __webpack_public_path__ + "img/blog2.75d2261b.jpg";